import { BffReview } from '@/__generated/beffe/sdk';
import { TRating, TReview } from '@/types';

export interface IReviewListProps {
	facilityName?: string;
	mobileWidth: boolean;
	reviews: Array<TReview>;
	filteredReviews?: Array<TReview>;
	filteredReviewsTitle?: string;
}

export interface IReviewListStateObject {
	displayedReview: TReview | null;
	showDialog: boolean;
}

export interface IReviewBarsProps {
	ratings: Array<TRating>;
	reviewCount: number;
}

export interface IOneReviewProps {
	review: BffReview | TReview;
	showFullReview?: boolean;
	dataTestId: string;
	mobileWidth?: boolean;
}

export interface IReviewsDialogOrDrawer {
	open: boolean;
	facilityName: string | undefined;
	handleCloseDialog: () => void;
	mobileWidth: boolean;
	reviews: TReview[];
	showFullReview?: boolean;
	loading?: boolean;
	hasMore?: boolean;
	onLoadMore?: () => void;
}

export const SCHEMA_REVIEWS_LIMIT = 50;

// max rating is always 5
export const FILTERED_REVIEWS_MAX_RATING = 5;

// need to show only 3 in UI
// some reviews may not have comments
// so fetching 10 and getting 3 with the comments to be safe
export const FILTERED_REVIEWS_TAKE = 10;

export const REVIEW_STARS_COUNT = 5;

export const clampRating = (n: number) => {
	if (Number.isNaN(n)) return 0;
	return Math.max(0, Math.min(REVIEW_STARS_COUNT, n));
};

export const REVIEWS_MIN_RATING = 1;
export const REVIEWS_PAGE_SIZE = 10;
